import {
  type ViewExtensionContext,
  ViewExtensionProvider,
} from '@blocksuite/affine/ext-loader';

import { patchDatabaseBlockConfigService } from './database-block-config-service';

export interface AffineDatabaseViewOptions {}

export class AffineDatabaseViewExtension extends ViewExtensionProvider<AffineDatabaseViewOptions> {
  override name = 'affine-database-view';

  override setup(
    context: ViewExtensionContext,
    options?: AffineDatabaseViewOptions
  ) {
    super.setup(context, options);

    // Register all database config extensions (including fullscreen menu)
    context.register(patchDatabaseBlockConfigService());
  }
}
